module.exports = __webpack_public_path__ + "static/media/image-4.e1a431ec.png";